// extracted by mini-css-extract-plugin
module.exports = {"pane":"StandGenders-pane-01c3"};